export default (clinicId?: number | string): boolean => {
    return parseInt(`${clinicId}`) === 2;
};
